import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AgentsPage } from '@/pages/referrer/agents';
import { agentsSearchSchema } from '@/routes/-shared/agentsSearchSchema';
import { ensureAuthData } from '@/api/auth/auth-query';
import { queryClient } from '@/api/common/client';
import { REFERRER_DASHBOARD } from '@/lib/constants/routes';
import { ReferrerType } from '@/lib/auth/models';

/**
 * Solo un rivenditore ha agenti. La lista resta montata e dettaglio e
 * creazione si aprono sopra di lei sull'`Outlet` (`$id`, `new`).
 */
export const Route = createFileRoute('/referrer/_layout/agents/_layout')({
  beforeLoad: async () => {
    const data = await ensureAuthData(queryClient);
    if (data.user?.referrerType !== ReferrerType.RESELLER) {
      throw redirect({ to: REFERRER_DASHBOARD });
    }
  },
  component: AgentsLayout,
  validateSearch: agentsSearchSchema,
});

function AgentsLayout() {
  return (
    <>
      <AgentsPage />
      <Outlet />
    </>
  );
}
